import { createRoot } from "react-dom/client";
import React from "react";
import App from "./App.tsx";
import "./styles/global.css";
import "./i18n/config";
import { bootstrapHashRouterFromPathname } from "./hashRouterBootstrap";

// Initialize Sentry lazily — keeps it out of the critical render path
import("./lib/utils/sentry.ts").then(({ initSentry }) => initSentry());

bootstrapHashRouterFromPathname();

// Accessibility runtime checking in development
if (import.meta.env.DEV) {
  import("@axe-core/react").then((axe) => {
    axe.default(React, createRoot, 1000);
  });
}

// i18n is now bundled with the app, no need for Suspense
createRoot(document.getElementById("root")!).render(<App />);
